module.exports = __webpack_public_path__ + "ptc_nakagawa_Q2.601c1ccc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_Q2.jpg
// module id = 29Qn
// module chunks = 0